var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpremljaj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1738",
    "data-name": "Group 1738",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 99.134,
    viewBox: "0 0 65 99.134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2713",
    "data-name": "Rectangle 2713",
    width: 65,
    height: 99.134,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2712",
    "data-name": "Rectangle 2712",
    width: 65,
    height: 99.134,
    rx: 10,
    transform: "translate(0)",
    fill: "#cad9f9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1576",
    "data-name": "Group 1576",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1575",
    "data-name": "Group 1575",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2942",
    "data-name": "Path 2942",
    d: "M278.624,55.923,282,34.616a20.7,20.7,0,0,1,11.879,6.056Z",
    transform: "translate(-222.348 -26.813)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2943",
    "data-name": "Path 2943",
    d: "M204.5,54.923,219.75,39.672a21.571,21.571,0,1,1-30.506,0,20.923,20.923,0,0,1,18.627-6.053Z",
    transform: "translate(-148.222 -25.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2944",
    "data-name": "Path 2944",
    d: "M278.615,76.722l9.791,19.22a21.573,21.573,0,0,0,9.429-29.012,20.506,20.506,0,0,0-3.968-5.459Z",
    transform: "translate(-222.341 -47.613)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2945",
    "data-name": "Path 2945",
    d: "M65.9,298.687l-4.694-4.7,9.221-9.211,4.689,4.7Z",
    transform: "translate(-53.938 -220.585)",
    fill: "#0253a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2946",
    "data-name": "Path 2946",
    d: "M119.812,159.689a21.856,21.856,0,1,0-6.4,15.439,21.662,21.662,0,0,0,6.4-15.439m-21.8,17.286a17.259,17.259,0,1,1,12.193-5.05,17.182,17.182,0,0,1-12.193,5.05",
    transform: "translate(-65.506 -106.77)",
    fill: "#0063cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2947",
    "data-name": "Path 2947",
    d: "M10.751,326.955,2.582,318.78l14.567-14.553,8.166,8.177Z",
    transform: "translate(-8.532 -235.647)",
    fill: "#0063cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2948",
    "data-name": "Path 2948",
    d: "M10.753,337.475,2.583,329.3l11.5-11.492,8.167,8.178Z",
    transform: "translate(-8.533 -246.166)",
    fill: "#387bff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_92",
    "data-name": "Line 92",
    y1: 6.123,
    x2: 6.131,
    transform: "translate(4.567 77.573)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2949",
    "data-name": "Path 2949",
    d: "M6.3,380.748a6.307,6.307,0,0,1-6.3-6.31q.756-.757,1.514-1.513,3.154,3.156,6.305,6.308L6.3,380.748",
    transform: "translate(-6.532 -288.859)",
    fill: "#0063cb"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpremljaj);
export default __webpack_public_path__ + "static/media/spremljaj.7cbf554dc006a7d320c2dc52975c49b9.svg";
export { ForwardRef as ReactComponent };